import { compareDuelsForListing } from '@/helpers/duels-sort';
import type { UiDuel } from '@/hooks/data/duels';

/** Initial / scope-change order: popularity sort. Vote mutations must not re-run this. */
export function initialFrozenDuelOrder(duels: UiDuel[]): string[] {
  return [...duels].sort(compareDuelsForListing).map(duel => duel.id);
}

export function orderDuelsByFrozenIds(duels: UiDuel[], frozenIds: string[]): UiDuel[] {
  const byId = new Map(duels.map(duel => [duel.id, duel]));
  const ordered: UiDuel[] = [];

  for (const id of frozenIds) {
    const duel = byId.get(id);
    if (duel) ordered.push(duel);
  }

  return ordered;
}

/**
 * Keep prior ids in place; drop missing; append newcomers (sorted among themselves).
 * Mirrors captain candidate freeze in CaptainDuel.
 */
export function nextFrozenDuelOrder(prev: string[], duels: UiDuel[]): string[] {
  const present = new Set(duels.map(duel => duel.id));
  const kept = prev.filter(id => present.has(id));
  const keptSet = new Set(kept);
  const appended = [...duels]
    .filter(duel => !keptSet.has(duel.id))
    .sort(compareDuelsForListing)
    .map(duel => duel.id);

  if (appended.length === 0 && kept.length === prev.length) {
    return prev;
  }

  return [...kept, ...appended];
}
